const CLOUDFRONT_URL = 'https://dlttx48mxf9m3.cloudfront.net';
const S3_URL = 'https://castus-vod-dev.s3.us-east-1.amazonaws.com';

/**
 * This is simply used for what you want the base URL to point to. Either
 * The AWS S3 bucket, or the Cloudfront URL.
 */
export const BASE_PATH = CLOUDFRONT_URL;
export const CLOUDFRONT_PATH = CLOUDFRONT_URL;
export const S3_PATH = S3_URL;
